/**
 * @Author: zpc
 * @DateTime: Created in 2021-08-12 14:00:00
 * @Description: 数据自动对接
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import Modal from 'src/types/iview/Modal';
 import Button from 'src/types/iview/Button';
 import Input from 'src/types/iview/Input';
 import { Toast } from 'src/util/toast';
 import { modalFactory } from 'src/util/vueExtend';
 import { Integer } from 'src/types/base';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import AreaCascader from 'src/components/areaCascader/areaCascader';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import InputNumber from 'src/types/iview/InputNumber';
 import { createNamespace } from 'src/util/bem';
 import { CommonUtil } from 'src/util/commonUtil';
 import DataButtJoinApi, { DataButtJointDOI } from './api/dataButtJointApi';
import { component } from 'vue-tsx-support';
import EnumEntity from 'src/enums/enumEntity';
import EnumIsOpenStatus,{EnumIsTokenStatus, EnumIsUrlParameterStatus, EnumIsHeaderTokenStatus} from 'src/enums/enumDataButtJoint';
import EnumOperates from 'src/enums/enumOperates';


 export namespace dataButtJointVOI {
    export interface PropsI {
        operate: string;
        id?: number;
        saveSuccess?(): void;
        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        dispose_site: Integer; // 站点id
        is_open: Integer; //是否开启数据上传
        is_token: Integer; // 是否需要验证token
        token_url?: string; //鉴权url
        token_user_name?: string; //鉴权url账号
        token_password?: string; // 鉴权url密码
        is_url_parameter?:Integer; //鉴权是否url传参
        is_header_token?: Integer; // 是否header上传token
        post_url: string; //数据上传url
        parameter: string; // 数据上传所需因子
        operationalSite: { deviceId: Integer; components: string[]; key: number,mn:string }[];
        cn:string;
    }
}

@Component
class DataButtJointModal extends Vue.Component<dataButtJointVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    isShowTokenInfo: boolean = false;

    formData: dataButtJointVOI.FormDataI = {
        dispose_site: null, // 站点id
        is_open: null, //是否开启数据上传
        is_token: null, // 是否需要验证token
        post_url: '', //数据上传url
        parameter: '', // 数据上传所需因子
        operationalSite: [{ deviceId: null, components: [], key: 0, mn:'' }],
        token_url:'',
        token_user_name:'',
        token_password:'',
        is_url_parameter: null,
        is_header_token: null,
        cn:'',
    };

    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        debugger
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        debugger
        let res;
        this.loading = true;
        if(this.formData.is_token === 1){
            let params: DataButtJoinApi.AddOrEditParamsI = {
                ...this.formData,
                token_url: this.formData.token_url, //鉴权url
                token_user_name: this.formData.token_user_name, //鉴权url账号
                token_password: this.formData.token_password, // 鉴权url密码
                is_url_parameter : this.formData.is_url_parameter, //鉴权是否url传参
                is_header_token: this.formData.is_header_token, // 是否header上传token
            };
        } 
        else{
            let params: DataButtJoinApi.AddOrEditParamsI = {
                ...this.formData,
            };
        }
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await DataButtJoinApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id;
                res = await DataButtJoinApi.edit(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }

    }

    async mounted() {
        var aaa = this.id
        if (this.operate === EnumOperates.Update.getName()) {
            let { code, data } = await DataButtJoinApi.searchSingleData({id: this.id});
            if (code === 0) {
                var aaaaaaaa = data
                this.formData = {
                    ...data,
                    dispose_site:data.device_id,
                };
                setTimeout(()=> {
                    (this.$refs.area as any).matchData()
                })
            }
        }
    }

    render(h) {
        return (
            <Modal
                class={createNamespace('modal')}
                title={this.operate + '对接站点信息'}
                width="800"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <i-form class={createNamespace('mt20')} ref="formValidate" labelWidth={150} model={this.formData} rules={this.rules}>
                    <form-item label="站点名称" prop="dispose_site" required type="number" style="display: inline-block;width:45%">
                         <EntitySelect type={EnumEntity.Station.getId()} v-model={this.formData.dispose_site} />
                    </form-item>
                    <form-item label="开启数据上传" prop="is_open" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumIsOpenStatus.getList() as any} v-model={this.formData.is_open} placeholder="请输入" />
                    </form-item>
                    <form-item label="是否验证token" prop="is_token" style="display: inline-block;width:45%" required type="number">
                        <CommonSelect dataSource={EnumIsTokenStatus.getList() as any} v-model={this.formData.is_token} placeholder="请输入" />
                    </form-item>
                    <form-item label="鉴权API" prop="token_url" style="display: inline-block;width:85%">
                        <Input placeholder="请输入" v-model={this.formData.token_url} />
                    </form-item>
                    <form-item label="鉴权账号" prop="token_user_name" style="display: inline-block;width:45%">
                        <Input placeholder="请输入" v-model={this.formData.token_user_name} />
                    </form-item>
                    <form-item label="鉴权密码" prop="token_password" style="display: inline-block;width:45%">
                        <Input placeholder="请输入" v-model={this.formData.token_password} />
                    </form-item>
                    <form-item label="鉴权url传参" prop="is_url_parameter" style="display: inline-block;width:45%"  type="number">
                        <CommonSelect dataSource={EnumIsUrlParameterStatus.getList() as any} v-model={this.formData.is_url_parameter} placeholder="请输入" />
                    </form-item>
                    <form-item label="是否header上传token" prop="is_header_token" style="display: inline-block;width:45%"  type="number">
                        <CommonSelect dataSource={EnumIsHeaderTokenStatus.getList() as any} v-model={this.formData.is_header_token} placeholder="请输入" />
                    </form-item>
                    <form-item label="数据上传API" prop="post_url" style="display: inline-block;width:85%" required>
                        <Input placeholder="请输入" v-model={this.formData.post_url} />
                    </form-item>
                    <form-item label="数据上传所需因子" prop="parameter" style="display: inline-block;width:65%" required>
                        <Input placeholder="请输入" v-model={this.formData.parameter} />
                    </form-item>
                    <form-item label="数据上传所需CN" prop="cn" style="display: inline-block;width:65%" required>
                        <Input placeholder="请输入" v-model={this.formData.cn} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}


export default function alertDataButtJointModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<dataButtJointVOI.PropsI>(DataButtJointModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}